import PortalAppService from "../../../application/platform/portal-app-service";
import { usePncpBiddingDetailDispatch } from "./pncp-bidding-detail-context";
import { ACTION_TYPES } from "./pncp-bidding-detail-reducer";

export const PNCP_ITEMS_PAGE_SIZE = 20;

export const usePncpBiddingDetailController = () => {
    const dispatch = usePncpBiddingDetailDispatch();

    const loadBiddingDetail = async (id: number) => {
        dispatch({ type: ACTION_TYPES.LOAD_START });
        try {
            const biddingDetail = await PortalAppService.getPncpBiddingDetail(id);
            dispatch({ type: ACTION_TYPES.LOAD_SUCCESS, payload: biddingDetail });
        } catch (error: any) {
            dispatch({ type: ACTION_TYPES.LOAD_ERROR, payload: error?.response?.data?.message || 'Erro ao carregar detalhes da licitação' });
        }
    };

    // As páginas de itens do PNCP começam em 1 e não trazem o total: há mais enquanto a página vem cheia
    const loadItems = async (id: number, page: number) => {
        dispatch({ type: ACTION_TYPES.LOAD_ITEMS_START });
        try {
            const response = await PortalAppService.listPncpBiddingItems(id, { page, pageSize: PNCP_ITEMS_PAGE_SIZE });
            const items = response.items ?? [];
            dispatch({ type: ACTION_TYPES.LOAD_ITEMS_SUCCESS, payload: { items, page, hasMore: items.length === PNCP_ITEMS_PAGE_SIZE } });
        } catch (error: any) {
            dispatch({ type: ACTION_TYPES.LOAD_ITEMS_ERROR, payload: error?.response?.data?.message || 'Erro ao carregar os itens da licitação' });
        }
    };

    return { loadBiddingDetail, loadItems };
};
